import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Stack,
} from '@mui/material';
import { Summary } from './Summary';
import { ContactInformation } from './ContactInformation';
import { Details } from './Details';
import { InstituteAlert } from './InstituteAlert';
import { useIsDesktop } from 'Hooks';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';
import { useState } from 'react';
import { OpenClose } from './OpenClose';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ITherapy {
  data: ITherapySuppliersResult;
}

export const Therapy = ({ data }: ITherapy) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  return (
    <Accordion
      expanded={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      onKeyDown={onEnterOrEscapeKeyDown}
      sx={{
        width: '100%',
        p: isDesktop ? '24px 24px 32px 24px' : '24px 16px',
        bgcolor: '#FFF',
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        ':hover': {
          borderColor: 'primary.shade_200',
        },
      }}
      tabIndex={0}
    >
      <AccordionSummary expandIcon={null} tabIndex={-1} sx={{ p: 0 }}>
        <Stack>
          <Summary data={data} />
          {isDesktop && (
            <Divider
              orientation='horizontal'
              sx={{ m: '16px 0 24px 0', borderColor: 'primary.shade_200' }}
            />
          )}
          <ContactInformation data={data} isOpen={isOpen} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Details data={data} />
        {data.isByInstitute && (
          <InstituteAlert instituteName={data.instituteName} />
        )}
        {!isDesktop && isOpen && <OpenClose isOpen={isOpen} />}
      </AccordionDetails>
    </Accordion>
  );
};
